import classNames from 'classnames/bind';
import React from 'react';

import styles from './index.module.scss';
import SelectForMavLink from './SelectForMavLink';

const cx = classNames.bind(styles);

const AddCommandBar = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('title')}>Add Command</div>
      <SelectForMavLink />
    </div>
  );
};

export default AddCommandBar;
